import React from 'react';
import { ToolHistoryEntry } from '../hooks/useToolHistory';

interface ToolHistorySectionProps<T> {
    history: ToolHistoryEntry<T>[];
    selectedHistoryId: string | null;
    onLoadHistory: (entry: ToolHistoryEntry<T>) => void;
    onClearHistory: () => void;
    formatDescription: (entry: ToolHistoryEntry<T>) => string;
    title?: string;
}

export function ToolHistorySection<T>({
    history,
    selectedHistoryId,
    onLoadHistory,
    onClearHistory,
    formatDescription,
    title = "Recent Scans"
}: ToolHistorySectionProps<T>) {
    const formatDate = (date: Date | string): string => {
        const d = new Date(date);
        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    if (history.length === 0) {
        return null;
    }

    return (
        <div style={{
            marginBottom: '24px',
            padding: '16px',
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '12px',
            }}>
                <h4 style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#111827',
                }}>
                    📋 {title}
                </h4>
                <button
                    onClick={onClearHistory}
                    style={{
                        padding: '4px 8px',
                        backgroundColor: '#fee2e2',
                        color: '#dc2626',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '500',
                        transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#fecaca';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#fee2e2';
                    }}
                >
                    Clear History
                </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {history.map((entry) => (
                    <button
                        key={entry.id}
                        onClick={() => onLoadHistory(entry)}
                        style={{
                            padding: '8px 12px',
                            backgroundColor: selectedHistoryId === entry.id ? '#dbeafe' : 'white',
                            border: `1px solid ${selectedHistoryId === entry.id ? '#3b82f6' : '#e5e7eb'}`,
                            borderRadius: '6px',
                            cursor: 'pointer',
                            textAlign: 'left',
                            transition: 'all 0.2s',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#eff6ff';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 
                                selectedHistoryId === entry.id ? '#dbeafe' : 'white';
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}>
                            <div>
                                <div style={{
                                    fontSize: '14px',
                                    color: '#111827',
                                    fontWeight: '500',
                                }}>
                                    {formatDescription(entry)}
                                </div>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#6b7280',
                                    marginTop: '2px',
                                }}>
                                    {formatDate(entry.timestamp)}
                                </div>
                            </div>
                            {selectedHistoryId === entry.id && (
                                <span style={{ color: '#3b82f6' }}>✓</span>
                            )}
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
} 